
import { PunkGameConfig } from "../../../../PunkGameConfig";
import { Timeline, TimelineLite, TweenLite, Ease, Power2, Bounce } from "gsap";
import { PunkParsedGameData } from "../../../../server/data/PunkParsedGameData";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { StateSymbolWin, IWinItem } from "../../../independent/symbol/StateSymbolWin";
import { PunkBackground } from "../../../../background/PunkBackground";
import { Container, Point } from "pixi.js";
import { ReelGraphicBackground } from "../../../independent/background/ReelGraphicBackground";
import { PosterManager } from "../../../independent/Poster/PosterManager";
import { SoundConfig } from "../../../../SoundConfig";
import { SoundManager } from "../../../../resource/sound/SoundManager";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { IWinRatioConfig } from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import { WinCounter } from "../../../independent/countup/WinCounter";
import { JumpingWildController } from "../../../independent/jumpingWild/JumpingWildController";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { PunkEngineManager } from "../../../../punkEngine/PunkEngineManager";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { IPunkBetWinData } from "../../../../server/data/PunkServerData";
import {PunkGameModuleConfig} from "../../../../PunkGameModuleConfig";

class BigWinStates extends StateHandler{
    public static readonly START:string = "start";
    public static readonly SHOW:string = "show";
    public static readonly STOP:string = "stop";
    public static readonly DONE:string = "done";
}

export class BigWinPresentation extends Presentation {

    private _winRatios:IWinRatioConfig[];
    private _gameData:PunkParsedGameData;

    private _winLevel:number = 0;
    private _currLevel:number = 0;

    private _bigWinStates:BigWinStates = new BigWinStates();
    private _isBonus:boolean = false;

    private _totalWinCombo:number = 0;

    public initialization(){
        this._winRatios = PunkGameConfig.instance.WIN_RATIOS.bigWin;
        WinCounter.bigwinCounter.position.set(0,0);
    }

    public setParsedGamedData(data:PunkParsedGameData):void {
        this._gameData = data;
        this._bigWinStates.set(BigWinStates.START);
        this._isBonus = data.nextMode == GameMode.FREESPIN || data.mode == GameMode.FREESPIN;

        this._totalWinCombo = data.allWinData.totalWinCombination;

        for(let  i:number = 0; i < this._winRatios.length;i++){
            if(this._winRatios[i].ratio > (data.singleWin/data.playedBetValue)){
                this._winLevel = i;
                break;
            } 
        }
        if(this._winLevel == 0) this._winLevel = this._winRatios.length - 1
    }
  
    public checkForActivation(data:PunkParsedGameData):boolean{ return data.isBigWin; }

    public getPresentation():void {
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        switch (this._bigWinStates.state) {
            case BigWinStates.START:
                this.preWin();
                break;
            case BigWinStates.SHOW:
                this.playBigWinLevelAnimation();
                break;
            case BigWinStates.STOP:
                this.postWin();
                break;
            case BigWinStates.DONE:
                this.PresentationState.set(PresentationState.INACTIVE);
                break;
            default:
                break;
        }
    }

    private preWin():void{
        this._bigWinStates.set( BigWinStates.SHOW);
        this.visible = true;
        // SlotGame.keypad.hide();
        for(let groups = 0; groups < this._gameData.punkBetWins.length;groups++){
            const winData:IPunkBetWinData = this._gameData.punkBetWins[groups];
            for(let reel = 0; reel < winData.reelWinPositions.length;reel++){
                let posRow:boolean[] = winData.reelWinPositions[reel];
                for(let row = 0; row < posRow.length; row++){
                    if(posRow[row]){
                        const item:Container =  (StateSymbolWin.instance.getItem(reel,row,"normal") as IWinItem).itemContainer;
                        const scaleOrigin:Point = new Point(item.scale.x,item.scale.y);
                        this.pTimeline.add(() => TweenLite.to(item.scale,0.1,{x:scaleOrigin.x*1.2,y:scaleOrigin.y*1.2,ease:Power2.easeOut}),0)
                        this.pTimeline.add(() => TweenLite.to(item.scale,0.1,{x:scaleOrigin.x,y:scaleOrigin.y, ease:Power2.easeIn}),0.1)
                    }
                }
            }
        }

        const lvlSound:string = SoundConfig.instance.BIG_WIN_LVL[Math.min(this._currLevel,SoundConfig.instance.BIG_WIN_LVL.length-1)];
        SoundManager.playSoundEffect(lvlSound);
        SoundManager.bonusMusicBigWin(false);
     
        PosterManager.instance.startBigwin(PosterManager.instance.bigWinTypeLvl(0));
        PosterManager.instance.setInteractive(true);
        this.pTimeline.to(this,1.3,{})
    }

    private postWin():void{
        PosterManager.instance.setInteractive(false);
        this._bigWinStates.set( BigWinStates.DONE);
        const initialDelay:number = 1;
        const bgDisappearDur:number = 1;
        const bgDisappearDelay:number = initialDelay + .5;
        const symbolIdleSwitchDelay:number = .08;
        let countupGoUpDelay:number = initialDelay + .5;

        this.pTimeline.to(WinCounter.bigwinCounter.scale,0.15,{x:1.24,y:1.24},0);
        this.pTimeline.to(WinCounter.bigwinCounter.scale,0.3,{x:1,y:1,ease:Bounce.easeOut},0.15);

        if(this._gameData.mode == GameMode.FREESPIN)
            this.pTimeline.add(() => SoundManager.fadeAmbienceLoop(1,2000), 0.3);
        else if(this._gameData.mode != GameMode.RESPIN) 
            this.pTimeline.add(() => SoundManager.fadeAmbienceLoop(1,3000), 0.3);

        this.pTimeline.add(() => PosterManager.instance.endBigWin(true),0);

        for(let groups = 0; groups < this._gameData.punkBetWins.length;groups++){
            const winData:IPunkBetWinData = this._gameData.punkBetWins[groups];
            for(let reel = 0; reel < winData.reelWinPositions.length;reel++){
                let posRow:boolean[] = winData.reelWinPositions[reel];
                for(let row = 0; row < posRow.length; row++){
                    if(posRow[row] && JumpingWildController.instance.itemExists(reel,row) == -1){
                        this.pTimeline.add(() => StateSymbolWin.instance.playSymbolStopWinAnimation({
                            ReelID:reel,
                            SymID:row,
                            duration: 0.4,
                            State:ReelSymbolStates.NORMAL,
                        }), symbolIdleSwitchDelay * (reel * 3 + row));
                    }
                }
            }
        }

        this.pTimeline.to(ReelGraphicBackground.instance, bgDisappearDur,{alpha:0}, bgDisappearDelay);

        this.pTimeline.add(() => PunkEngineManager.RSWindow((reel:number,symid:number) => {
            PunkEngineManager.getReel(reel).getSymbol(symid)!.setActive(true);
        }));

        this.pTimeline.add(() => WinCounter.bigwinCounter.moveUp(), countupGoUpDelay);
        this.pTimeline.add([
            () => WinCounter.winWayCounter.updateWinWays(this._totalWinCombo),
            () => WinCounter.winWayCounter.showWaysWon(1),
        ], countupGoUpDelay + 0.5);
        
        countupGoUpDelay += 1.5;
        this.pTimeline.fromTo(WinCounter.bigwinCounter,0.8,{alpha:1},{alpha:0}, countupGoUpDelay);
        if(!this._isBonus) this.pTimeline.add(PunkBackground.instance.changeGraphicAlpha(0.8,0), countupGoUpDelay);

        this.pTimeline.add(() => WinCounter.winWayCounter.waysBigWonHide(),countupGoUpDelay);
    }

    public playBigWinLevelAnimation():void {
        if(this._winLevel === this._currLevel){
            const lastSound:string = SoundConfig.instance.BIG_WIN_LVL[Math.min(this._currLevel-1,SoundConfig.instance.BIG_WIN_LVL.length-1)];
            const isTotalWin:boolean = this._gameData!.totalWin != this._gameData.singleWin;

            SoundManager.stopSoundEffect(lastSound);
            SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_MUSIC);
            SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_COUNT);

            SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_COUNT_END);
            SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_MUSIC_END);
            this._bigWinStates.set(BigWinStates.STOP);
            this.pTimeline.add(() => SlotGame.keypad.setWin(this._gameData!.totalWin, isTotalWin, PunkGameModuleConfig.featurePrice.isWinBelowStake()));
        }else{
            
            if(this._currLevel == 0){
                WinCounter.bigwinCounter.alpha = 1;
                SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_MUSIC,10000000000);
            }

            let countUpDurr:number = this._winRatios[this._currLevel].duration;
            if(this._winLevel != 1 && this._gameData.singleWin - this._winRatios[this._currLevel].ratio < 5)
                countUpDurr /= 3;

            this.pTimeline.add(this.playBigWinCountUp(this._currLevel, countUpDurr),0);

            if(this._currLevel <= 3 && this._currLevel != 0){
                const lastSound:string = SoundConfig.instance.BIG_WIN_LVL[Math.min(this._currLevel-1,SoundConfig.instance.BIG_WIN_LVL.length-1)];
                SoundManager.stopSoundEffect(lastSound)
                const lvlSound:string = SoundConfig.instance.BIG_WIN_LVL[Math.min(this._currLevel,SoundConfig.instance.BIG_WIN_LVL.length-1)];
                SoundManager.playSoundEffect(lvlSound)
            }

            this._currLevel++;
            if(this._gameData!.playedBetValue * PunkGameConfig.instance.WIN_RATIOS.bigWin[this._currLevel].ratio == this._gameData!.singleWin){
                this._currLevel = this._winLevel;
            }
            if(this._winLevel !== this._currLevel && this._currLevel <= 3){
                this.pTimeline.to(WinCounter.bigwinCounter.scale,0.15,{x:1.24,y:1.24},0);
                this.pTimeline.to(WinCounter.bigwinCounter.scale,0.3,{x:1,y:1,ease:Bounce.easeOut},0.15);
                this.pTimeline.add(() => PosterManager.instance.lvlUp(),"-=0.4");
                this.pTimeline.add([
                    () => PosterManager.instance.startBigwin(PosterManager.instance.bigWinTypeLvl(this._currLevel)),
                    TweenLite.to(WinCounter.bigwinCounter.scale,0.15,{x:1.24,y:1.24}),
                    TweenLite.to(WinCounter.bigwinCounter.scale,0.3,{delay:0.15, x:1,y:1,ease:Bounce.easeOut})
                ]);
            }
        }
    }

    protected playBigWinCountUp(level:number, duration:number):Timeline | null {
        const fromValue:number = level === 0 ? 0 : this._gameData!.playedBetValue * PunkGameConfig.instance.WIN_RATIOS.bigWin[level].ratio;
        const toValue:number = level+1 === this._winLevel ? this._gameData!.singleWin : this._gameData!.playedBetValue * PunkGameConfig.instance.WIN_RATIOS.bigWin[level + 1].ratio;
        const timeline:TimelineLite = new TimelineLite();
        if(level == 0) timeline.fromTo(WinCounter.bigwinCounter,0.2,{alpha:0},{alpha:1},0);
        timeline.add([
            () => SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_COUNT,10000000000),
            WinCounter.bigwinCounter.getCountUpAnimation(fromValue, toValue, duration)
        ]);

        timeline.add(() => SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_COUNT));

        return timeline;
    }

    public stopPresentation():void {
        this.visible  = false;
        this._winLevel = 0;
        this._currLevel = 0;
        WinCounter.bigwinCounter!.disableCounter();
        PosterManager.instance.killBigWin();
        WinCounter.newMidPos();
    }

    public skipPresentation():void{
        if(this._bigWinStates.equal(BigWinStates.SHOW)){
            this.pTimeline!.totalProgress(1);
            TweenLite.to(WinCounter.bigwinCounter.scale,0.15,{x:1.24,y:1.24});
            TweenLite.to(WinCounter.bigwinCounter.scale,0.3,{delay:0.15, x:1,y:1,ease:Bounce.easeOut});
        }
    }
}